import React from 'react'

interface CardProps {
  children: React.ReactNode
  className?: string
  title?: string
  action?: React.ReactNode
}

const Card: React.FC<CardProps> = ({ children, className, title, action }) => {
  return (
    <div className={`bg-card border border-border rounded-lg shadow-sm p-6 ${className}`}>
      {title && (
        <div className="flex justify-between items-center mb-4 border-b border-border pb-3">
          <h2 className="text-card-foreground text-xl font-semibold">
            {title}
          </h2>
          {action && (
            <div className="flex-shrink-0">
              {action}
            </div>
          )}
        </div>
      )}
      <div className="text-card-foreground">
        {children}
      </div>
    </div>
  )
}

export default Card
